export const AboutData = {
  firstName: 'Donghun',
  lastName: 'Kim',
  about1: '<A Developer who loves challenges />',
  about2: '<Backend developer />',
};
